import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ad93b4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-tag-wrap" }

import { computed } from 'vue'
import { xcareTypeClassNameMap } from './service-tag'

export default /*#__PURE__*/_defineComponent({
  __name: 'service-tag',
  props: {
    serviceType: null
  },
  setup(__props: any) {

const prop = __props as {
  serviceType: Array<string>
};



const serviceTypeListClass = computed(() => {
  return (prop.serviceType || []).map((_) => {
    return xcareTypeClassNameMap[_].join(' ')
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(serviceTypeListClass), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["tag-wrap base-type", item])
      }, null, 2))
    }), 128))
  ]))
}
}

})